import { defineComponent as _defineComponent } from 'vue'
import Student from "@/interfaces/student.interface";
import UserAvatar from "../user-avatar.component.vue";
import { ref } from "vue";
import { MessageBox } from "element-ui";
import useHttpRequest from "@/composables/use-http-request";
import ChangeProfilePictureDialog from "@/components/dialogs/change-profile-picture-dialog.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'my-profile.component',
  props: {
    student: null
  },
  emits: ["on-refresh"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (event: "on-refresh"): void;
}), expose: any, slots: any, attrs: any }) {





const showUploadProfilePictureDialog = ref(false);

const removeProfilePicture = async () => {
  await MessageBox.confirm(
    "This will permanently delete your profile picture. Do you want to continue?",
    "Confirm photo removal",
    {
      // eslint-disable-line no-unreachable
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      type: "warning",
    }
  );

  const request = await useHttpRequest<{ success: boolean; message: string }>({
    method: "PATCH",
    url: `students/remove-profile-picture/${store.state.userId}`,
    loadingProperty: null,
    showSuccessMessage: true,
    showFullScreenLoader: true,
  });

  if (!request) return;
  if (request.success && request.message == "Photo removed successfully") {
    emit("on-refresh");
  }
};

return { __sfc: true,emit, showUploadProfilePictureDialog, removeProfilePicture, UserAvatar, ChangeProfilePictureDialog }
}

})